export default {
  data() {
    return {
      hint: '',
      timeout: '',
      is_focused: false
    }
  },
  computed: {
    hide_details() {
      let result = true
      if ( this.show_details_focused ) {
        if (this.counter ) {
          result = !this.is_focused
        } else if (this.max_length) {
          result = !this.hint
        }
      }
      if (this.show_details) {
        result = false
      }
      return result
    }
  },
  methods: {
    counterRule(value) {
      if ( !value ) {
        return true
      }
      let ref = this.$refs.bordered_textarea || this.$refs.combobox,
        count = this.counter || this.max_length

      let setLazyValue = () => {
        if ( ref?.lazyValue ) {
          ref.lazyValue = value
        }
      }

      if ( value.length > count ) {
        this.timeout = false
        value = value.substring(0, count )

        let input = ref?.$el.querySelector('textarea') || ref?.$el.querySelector('input')
        if ( input ) {
          input.value = value
        }
        setLazyValue()
        this.hint = this.$t('Common.MaxCharacters')
        this.model_text = value
        return this.$t('Common.MaxCharacters')

      } else if (this.hint && value.length == count && !this.timeout ) {
        this.timeout = setTimeout(() => {
          this.hint = ''
        }, 5000)

      } else if ( value.length <  count) {
        this.hint = ''
        this.timeout = ''
      }

      if ( this.ruleFunction ) {
        this.ruleFunction()
      }
      this.model_text = value
      return true
    },
    blur() {
      this.$emit('blur')
      this.is_focused = false
    },
    focus() {
      this.$emit('focus')
      this.is_focused = true
    }
  }
}
